function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Decimal from 'decimal.js';
import { DiscountModel, timeModel } from "./..";
import { LineItemType } from "./model";
import { AvailableCreditModel } from "../AvailableCreditModel";
export function fromDTO(invoiceDraftDTO) {
  var _invoiceDraftDTO$atta;
  const {
    issueDate,
    paymentDate,
    totalAmount
  } = invoiceDraftDTO;
  const credits = invoiceDraftDTO.credits.map(c => new AvailableCreditModel(c));
  const lineItems = invoiceDraftDTO.lineItems.map(lineItemFromDTO);
  return {
    attachments: (_invoiceDraftDTO$atta = invoiceDraftDTO.attachments) !== null && _invoiceDraftDTO$atta !== void 0 ? _invoiceDraftDTO$atta : [],
    issueDate: timeModel.fromDateStampObject(issueDate),
    paymentDate: timeModel.fromDateStampObject(paymentDate),
    totalAmount: new Decimal(totalAmount).div(100).toDP(),
    credits,
    lineItems
  };
}
function subLineItemsFromDTO(dto) {
  return dto === null || dto === void 0 ? void 0 : dto.map(subLineItem => ({
    name: subLineItem.name,
    discount: DiscountModel.fromDTO(subLineItem.discount),
    totalAmount: new Decimal(subLineItem.totalAmount).div(100).toDP(),
    rate: {
      unit: subLineItem.rate.unit,
      amount: new Decimal(subLineItem.rate.amount).div(100).toDP()
    },
    origin: subLineItem.origin ? {
      type: 'serviceBundle',
      serviceBundle: {
        bundleItemId: subLineItem.origin.serviceBundle.bundleItemId,
        serviceTemplateId: subLineItem.origin.serviceBundle.serviceTemplateId
      }
    } : undefined
  }));
}
function subLineItemsToDTO(subLineItems) {
  return subLineItems === null || subLineItems === void 0 ? void 0 : subLineItems.map(subLineItem => ({
    name: subLineItem.name,
    discount: subLineItem.discount ? subLineItem.discount.toDTO() : null,
    totalAmount: subLineItem.totalAmount.mul(100).toNumber(),
    rate: {
      unit: subLineItem.rate.unit,
      amount: subLineItem.rate.amount.mul(100).toNumber()
    },
    origin: subLineItem.origin ? {
      type: 'serviceBundle',
      serviceBundle: {
        bundleItemId: subLineItem.origin.serviceBundle.bundleItemId,
        serviceTemplateId: subLineItem.origin.serviceBundle.serviceTemplateId
      }
    } : undefined
  }));
}
export function lineItemFromDTO(dto) {
  switch (dto.source) {
    case LineItemType.Automatic:
      {
        return _objectSpread(_objectSpread({}, dto), {}, {
          source: LineItemType.Automatic,
          totalAmount: new Decimal(dto.totalAmount).div(100).toDP(),
          rate: _objectSpread(_objectSpread({}, dto.rate), {}, {
            amount: new Decimal(dto.rate.amount).div(100).toDP()
          }),
          automatic: _objectSpread(_objectSpread({}, dto.automatic), {}, {
            discount: DiscountModel.fromDTO(dto.automatic.discount)
          }),
          subLineItems: subLineItemsFromDTO(dto.subLineItems)
        });
      }
    case LineItemType.Manual:
      {
        return _objectSpread(_objectSpread({}, dto), {}, {
          source: LineItemType.Manual,
          totalAmount: new Decimal(dto.totalAmount).div(100).toDP(),
          rate: _objectSpread(_objectSpread({}, dto.rate), {}, {
            amount: new Decimal(dto.rate.amount).div(100).toDP()
          }),
          manual: _objectSpread(_objectSpread({}, dto.manual), {}, {
            quantity: dto.manual.quantity ? new Decimal(dto.manual.quantity).div(100).toDP() : null,
            discount: DiscountModel.fromDTO(dto.manual.discount)
          }),
          subLineItems: subLineItemsFromDTO(dto.subLineItems)
        });
      }
    case LineItemType.AdHocCharge:
      {
        return _objectSpread(_objectSpread({}, dto), {}, {
          source: LineItemType.AdHocCharge,
          totalAmount: new Decimal(dto.totalAmount).div(100).toDP(),
          rate: _objectSpread(_objectSpread({}, dto.rate), {}, {
            amount: new Decimal(dto.rate.amount).div(100).toDP()
          }),
          adHocCharge: _objectSpread(_objectSpread({}, dto.adHocCharge), {}, {
            quantity: new Decimal(dto.adHocCharge.quantity).div(100).toDP(),
            discount: DiscountModel.fromDTO(dto.adHocCharge.discount)
          })
        });
      }
    case LineItemType.Credit:
      {
        return _objectSpread(_objectSpread({}, dto), {}, {
          source: LineItemType.Credit,
          totalAmount: new Decimal(dto.totalAmount).div(100).toDP(),
          rate: _objectSpread(_objectSpread({}, dto.rate), {}, {
            amount: new Decimal(dto.rate.amount).div(100).toDP()
          })
        });
      }
    default:
      {
        throw new Error('unrecognized line item source');
      }
  }
}
export function toDTO(invoiceDraft) {
  const {
    issueDate,
    paymentDate,
    totalAmount
  } = invoiceDraft;
  const credits = invoiceDraft.credits.map(c => c.toJSON());
  const lineItems = invoiceDraft.lineItems.map(lineItemToDTO);
  return {
    attachments: invoiceDraft.attachments,
    issueDate: timeModel.toDateStampObject(issueDate),
    paymentDate: timeModel.toDateStampObject(paymentDate),
    totalAmount: totalAmount.mul(100).toNumber(),
    credits,
    lineItems
  };
}
export function lineItemToDTO(lineItem) {
  switch (lineItem.source) {
    case LineItemType.Automatic:
      {
        return _objectSpread(_objectSpread({}, lineItem), {}, {
          source: LineItemType.Automatic,
          totalAmount: lineItem.totalAmount.mul(100).toNumber(),
          rate: _objectSpread(_objectSpread({}, lineItem.rate), {}, {
            amount: lineItem.rate.amount.mul(100).toNumber()
          }),
          automatic: _objectSpread(_objectSpread({}, lineItem.automatic), {}, {
            discount: lineItem.automatic.discount && lineItem.automatic.discount.toDTO()
          }),
          subLineItems: subLineItemsToDTO(lineItem.subLineItems)
        });
      }
    case LineItemType.Manual:
      {
        return _objectSpread(_objectSpread({}, lineItem), {}, {
          source: LineItemType.Manual,
          totalAmount: lineItem.totalAmount.mul(100).toNumber(),
          rate: _objectSpread(_objectSpread({}, lineItem.rate), {}, {
            amount: lineItem.rate.amount.mul(100).toNumber()
          }),
          manual: _objectSpread(_objectSpread({}, lineItem.manual), {}, {
            quantity: lineItem.manual.quantity !== null ? lineItem.manual.quantity.mul(100).toNumber() : null,
            discount: lineItem.manual.discount && lineItem.manual.discount.toDTO()
          }),
          subLineItems: subLineItemsToDTO(lineItem.subLineItems)
        });
      }
    case LineItemType.AdHocCharge:
      {
        return _objectSpread(_objectSpread({}, lineItem), {}, {
          source: LineItemType.AdHocCharge,
          totalAmount: lineItem.totalAmount.mul(100).toNumber(),
          rate: _objectSpread(_objectSpread({}, lineItem.rate), {}, {
            amount: lineItem.rate.amount.mul(100).toNumber()
          }),
          adHocCharge: _objectSpread(_objectSpread({}, lineItem.adHocCharge), {}, {
            quantity: lineItem.adHocCharge.quantity.mul(100).toNumber(),
            discount: lineItem.adHocCharge.discount && lineItem.adHocCharge.discount.toDTO()
          })
        });
      }
    case LineItemType.Credit:
      {
        return _objectSpread(_objectSpread({}, lineItem), {}, {
          source: LineItemType.Credit,
          totalAmount: lineItem.totalAmount.mul(100).toNumber(),
          rate: _objectSpread(_objectSpread({}, lineItem.rate), {}, {
            amount: lineItem.rate.amount.mul(100).toNumber()
          })
        });
      }
    default:
      {
        throw new Error('unrecognized line item source');
      }
  }
}